import useUnsuspendedTranslation from "../hooks/useUnsuspendedTranslation";
import { Button } from "../App.styles";
import Error from "./Error";
import ExternalLinkButton from "./ExternalLinkButton";
import { ErrorActions } from "./Error.style";

const ErrorRecoveryActions = ({ t }) => (
  <ErrorActions>
    <Button color="primary" type="button" onClick={() => window.location.reload()}>
      {t("Refresh")}
    </Button>
    <ExternalLinkButton color="light" href="https://www.socialscavenger.com/contact/">
      {t("Contact Support")}
    </ExternalLinkButton>
  </ErrorActions>
);

const ErrorDisplay = ({ error }) => {
  const { t } = useUnsuspendedTranslation();
  const isNubError = (error?.response?.config?.url || "").match("/nubs.json");
  const status = error?.response?.status;
  const button = <ErrorRecoveryActions t={t} />;

  switch (status) {
    case 403:
      return (
        <Error
          title={t("Not Authorized")}
          message={t("You need to be a game administrator in order to take that action.")}
          button={button}
        />
      );
    case 404:
      return (
        <Error
          title={t("Not Found")}
          message={t("The resource you are looking for does not exist.")}
          button={button}
        />
      );
    case 406:
    case 500:
    case 501:
    case 502:
    case 503:
      const description = {
        406: t(`<strong>Error 406</strong>: <em>The browser has requested a response using Accept- headers that the server cannot fulfill.</em>`),
        500: t(`<strong>Error 500</strong>: <em>The server encountered an unexpected condition that prevented it from fulfilling the request.</em>`),
        501: t(`<strong>Error 501</strong>: <em>The server does not support the functionality required to fulfill the request.</em>`),
        502:
            // show specific error for AI nubs creation
            isNubError
                ? t(`<em>You're only able to create ${process.env.REACT_APP_MAX_AI_PER_HOUR} AI generated photos in an hour. Please wait and try again later.</em>`)
                : t(`<strong>Error 502</strong>: <em>The server, while acting as a gateway or proxy, received an invalid response from the upstream server.</em>`),
        503: t(`<strong>Error 503</strong>: <em>The server is not ready to handle the request.</em>`),
      };
      const title = {
        500: t(`Server error`),
        501: t(`Server error`),
        502: isNubError ? t(`Limit Reached`) : t(`Server error`),
        503: t(`Server error`),
      };
      return (
        <Error
          title={title[status] || t("Lost connection")}
          message={description[status]}
          button={button}
        />
      );
    default:
      return (
        <Error
          title={t("An error occurred.")}
          message={t("An unexpected error occurred and we <br/>couldn't load this page. Please try again later <br/>or contact Social Scavenger support.")}
          button={button}
        />
      );
  }
};

export default ErrorDisplay;
